import { render, staticRenderFns } from "./Mehr.vue?vue&type=template&id=494061ab&"
import script from "./Mehr.vue?vue&type=script&lang=js&"
export * from "./Mehr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports